export function authRequestMiddleware(auth) {
  return function (url, options = {}) {
    var _options$headers, _options$headers2;
    if (!auth || !auth.state || !auth.state.access_token) {
      return;
    }
    const companyId = auth.state.claims.company_id;
    options.headers = {
      ...(options.headers || {}),
      'company-id': options !== null && options !== void 0 && (_options$headers = options.headers) !== null && _options$headers !== void 0 && _options$headers['company-id'] ? options.headers['company-id'] : companyId,
      'x-company-id': options !== null && options !== void 0 && (_options$headers2 = options.headers) !== null && _options$headers2 !== void 0 && _options$headers2['x-company-id'] ? options.headers['x-company-id'] : companyId,
      'authorization': `Bearer ${auth.state.access_token}`
    };
  };
}
export function authRouteMiddleware(auth) {
  return function (action, nextRoute, prevRoute) {
    var _nextRoute$state, _nextRoute$state$para;
    // we aren't signed in yet, so continue
    if (!auth.state.access_token) {
      return action.ok();
    }
    const nextCompanyId = nextRoute === null || nextRoute === void 0 ? void 0 : (_nextRoute$state = nextRoute.state) === null || _nextRoute$state === void 0 ? void 0 : (_nextRoute$state$para = _nextRoute$state.params) === null || _nextRoute$state$para === void 0 ? void 0 : _nextRoute$state$para.companyId;
    // if the next companyId is the same as the last companyId, continue
    if (nextCompanyId === auth.state.claims.company_id) {
      return action.ok();
    }
    if (nextCompanyId) {
      // switch to the new company
      auth.delegate(nextCompanyId).then(() => {
        action.ok();
      }).catch(error => {
        console.error(error);
      });
    } else {
      action.ok();
    }
  };
}
//# sourceMappingURL=auth.js.map